var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarketAgility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "speedometer-icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 677.17,
    height: 585.836,
    viewBox: "0 0 677.17 585.836",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00c6dc"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M320.455,291.964l157.61-100.407a2.7,2.7,0,0,1,3.582.331l15.21,16.2a2.767,2.767,0,0,1,.11,3.637L377.547,350.489c-16.973,18.241-35.1,21.823-49.708,17.084a41.007,41.007,0,0,1-18.461-12.4,42.488,42.488,0,0,1-9.589-19.894c-2.7-14.714,2.7-31.191,20.555-43.26l.11-.055ZM106.524,585.084A338.517,338.517,0,0,1,338.585,0,335.66,335.66,0,0,1,467.7,25.68,341.618,341.618,0,0,1,651.38,209.411a335.318,335.318,0,0,1-30.75,315.44A346.3,346.3,0,0,1,578.747,576.1a2.761,2.761,0,0,1-3.858,0l-16.918-16.863a2.488,2.488,0,0,1-.937-.606L509.862,511.46a2.761,2.761,0,0,1,0-3.858l24.744-24.744a2.761,2.761,0,0,1,3.858,0l36.427,36.427a301.6,301.6,0,0,0,21.217-31.412A293.943,293.943,0,0,0,636.556,344.7h-50.2a2.763,2.763,0,0,1-2.755-2.755V306.953a2.763,2.763,0,0,1,2.755-2.755h48.275a296.092,296.092,0,0,0-26.011-91.37A300.826,300.826,0,0,0,554.5,133.638l-32.293,32.293a2.761,2.761,0,0,1-3.858,0L493.6,141.187a2.761,2.761,0,0,1,0-3.858l31.136-31.136a298.842,298.842,0,0,0-81.946-46.842,295.223,295.223,0,0,0-92.306-18.627V84.977a2.763,2.763,0,0,1-2.755,2.755H312.684a2.763,2.763,0,0,1-2.755-2.755V41.827a297.038,297.038,0,0,0-170.615,74.892l32.349,32.349a2.761,2.761,0,0,1,0,3.858l-24.744,24.744a2.761,2.761,0,0,1-3.858,0L111.1,145.706A297.775,297.775,0,0,0,61.721,227.6,300.979,300.979,0,0,0,41,320.9H90.763a2.763,2.763,0,0,1,2.755,2.755V358.7a2.763,2.763,0,0,1-2.755,2.755H41.331a295.689,295.689,0,0,0,7.44,47.283,292.734,292.734,0,0,0,16.037,48.054,299.3,299.3,0,0,0,20.059,38.466,290.355,290.355,0,0,0,23.586,32.9l39.9-39.9a2.761,2.761,0,0,1,3.858,0L176.953,513a2.761,2.761,0,0,1,0,3.858c-22.815,22.815-44.583,44.693-66.626,68.114a2.645,2.645,0,0,1-3.8.11Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketAgility);
export default __webpack_public_path__ + "static/media/marketAgility.c016589fe34577b93404643570883086.svg";
export { ForwardRef as ReactComponent };